import { render, staticRenderFns } from "./AssembliesCRUD.vue?vue&type=template&id=1967a803&"
import script from "./AssembliesCRUD.vue?vue&type=script&lang=js&"
export * from "./AssembliesCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports